import { render, staticRenderFns } from "./SupportTicketEditDialog.vue?vue&type=template&id=3954db69"
import script from "./SupportTicketEditDialog.vue?vue&type=script&lang=js"
export * from "./SupportTicketEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports